import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItemGroupService {
  constructor(private router: Router, private http: HttpClient) { }

  private headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: '*/*'
  });

  GetItemGroups(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}ItemGroup/GetItemGroups`, body, options);
  }

  GetAllLedgerForCompany(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}ItemGroup/GetAllLedgerForCompany`, body, options);
  }

  GetAllTaxCategory(): Observable<any> {
    const body = new HttpParams({ });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}ItemGroup/GetAllTaxCategory`, body, options);
  }

  InsertItemGroup(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}ItemGroup/InsertItemGroup`, body, options);
  }

  UpdateItemGroup(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}ItemGroup/UpdateItemGroup`, body, options);
  }

  DeleteItemGroup(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}ItemGroup/DeleteItemGroup`, body, options);
  }

  GetItemGroupByID(data): Observable<any> {
    const body = new HttpParams({ fromObject: data });
    const options = { headers: this.headers };
    return this.http.post(`${environment.ASquareAPIURL}ItemGroup/GetItemGroupByID`, body, options);
  }
}
